export default () => ({
  setCurrentScreen: () => {},
  setUserId: () => {},
  resetAnalyticsData: () => {}
});
